// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3ueVE","image":"styles_image__3OIwx"};